import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ThumbsDown({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.0536 21.3334H10.6667H10.0876C8.76496 21.3334 7.80657 20.0725 8.16057 18.7981L9.12299 15.3334H6.45076C4.14566 15.3334 2.53633 13.0497 3.31162 10.8789L4.74019 6.87892C5.21399 5.55228 6.47062 4.66671 7.87933 4.66671H14.0001L14.0001 6.00004H7.87933C7.03411 6.00004 6.28013 6.53138 5.99585 7.32737L4.56728 11.3274C4.1021 12.6299 5.0677 14 6.45076 14H10.0001H10.8772L10.6424 14.8451L9.44526 19.1549C9.32726 19.5797 9.64672 20 10.0876 20H10.2799L14.0879 13.3359L14.2799 13H14.6667H16.0001V4.00004V3.33337H16.6667H20.6667V4.66671H17.3334V14.6667H20.6667V16H16.6667H16.0001V15.3334V14.3334H15.0536L11.2456 20.9975L11.0536 21.3334Z"
        fill={iconColor}
      />
    </Svg>
  );
}
